import { Col, Row } from "antd";
import { InputStyle, labelStyle } from "../constants";
import { useEffect, useState } from "react";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import InputNumberComponent from "../../../components/InputNumberComponent";
import { SwitchContainer } from "./styles";
import InputComponent from "../../../components/InputComponent";
import { useParams } from "react-router-dom";
import { useDiscoveryContext } from "../../../context/DiscoveryContext/DiscoveryContext";
import SelectComponent from "../../../components/SelectComponent";


const Info = () => {
	const { id } = useParams<{ id: string }>();
	const { discoveryData, setDiscoveryData, getDetails, getApplicationData, applicationData } = useDiscoveryContext();

	useEffect(() => {
		if (id) {
			getDetails(id);
			getApplicationData()
		}
	}, [id])

	const handleSelectChange = (value: string | undefined) => {
		setDiscoveryData({ ...discoveryData, applicationId: value });
	};

	useEffect(() => {
		console.log("info discoveryData", discoveryData)
	}, [discoveryData])



	return (
		<>
			<Row gutter={20}>
				<Col span={6}>
					<InputNumberComponent
						title={"Sıra No"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={discoveryData?.displayOrder}
						onChange={(value) => setDiscoveryData({ ...discoveryData, displayOrder: Number(value) })}
					/>
				</Col>
				<Col span={9}>
					<InputComponent
						title={"URL"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={discoveryData?.targetUrl}
						onChange={(e) => setDiscoveryData({ ...discoveryData, targetUrl: e.target.value })}
					/>
				</Col>
				<Col span={9}>
					<InputComponent
						title={"Tiny URL"}
						placeholder=""
						isRequired
						style={InputStyle}
						value={discoveryData?.tinyUrlName}
						onChange={(e) => setDiscoveryData({ ...discoveryData, tinyUrlName: e.target.value })}
					/>
				</Col>
			</Row >
			<Row gutter={20}>
				<Col span={6}>
					<SelectComponent
						title="Uygulama"
						isRequired
						value={discoveryData?.applicationId}
						style={{ marginBottom: "16px", width: "100%" }}
						options={applicationData}
						onChange={handleSelectChange}
					/>
				</Col>
				<Col span={6}>
					<SwitchContainer>
						<SwitchOptionComponent
							key={"isActive"}
							title={"Görünürlük"}
							labelStyle={labelStyle}
							value={discoveryData?.isVisible}
							onChange={(checked) => setDiscoveryData({ ...discoveryData, isVisible: checked })}
						/>
					</SwitchContainer>
				</Col>
			</Row>
		</>
	);
};

export default Info;
